const coverImage =
  'https://images.unsplash.com/photo-1594655151353-1ec2aa6bd8c9?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1901&q=80';

const validEmailRegex =
  // eslint-disable-next-line no-useless-escape
  /^([a-z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+\/=?^_`{|}~-]+)*)@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

export { coverImage, validEmailRegex };
